const noSearch = [
  "for_manager",
  "for_mentor",
  "series",
  "training_series_id",
  "days_from_start"
];

export default ({ ts_id, items, search, pagination }) => {
  const { offset, limit, setMax } = pagination;
  search = search.toLowerCase();
  const filtered = items
    .filter(message => message.training_series_id === parseInt(ts_id, 10))
    .filter(message => {
      for (let property in message) {
        const key = message[property].toString().toLowerCase();
        const willSearch = !noSearch.find(str => str === key);
        if (willSearch && key.includes(search)) {
          return true;
        }
      }
      return false;
    });

  setMax(filtered.length);

  return filtered
    .filter(
      (_, i) => i >= offset && i < parseInt(offset, 10) + parseInt(limit, 10)
    )
    .sort((a, b) =>
      a.days_from_start > b.days_from_start
        ? 1
        : b.days_from_start > a.days_from_start
        ? -1
        : 0
    );
};
// Sample message
// {
//     subject,
//     body,
//     link,
//     for_manager,
//     for_mentor,
//     series,
//     training_series_id,
//     days_from_start
// }
